import { Map } from 'immutable';
import { get } from 'lodash';
import Constants from '../../constants';

const initialState: any = Map();

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case Constants.CONVERSATION_AGENT_TAKEOVER_CANCELLED:
      return state.setIn([payload.channelName, 'loading'], false);

    case Constants.CONVERSATION_AGENT_TAKEOVER_EXCEPTION:
      return state
        .setIn([payload.channelName, 'errors'], payload.errors)
        .setIn([payload.channelName, 'loading'], true);

    case Constants.CONVERSATION_AGENT_TAKEOVER_REINSTATE:
      return state
        .setIn([payload.channelName, 'data'], null)
        .setIn([payload.channelName, 'errors'], [])
        .setIn([payload.channelName, 'loading'], false);

    case Constants.CONVERSATION_AGENT_TAKEOVER_REQUESTED:
      return state
        .setIn(
          [payload.channelName, 'data'],
          state.getIn([payload.channelName, 'data']) || null
        )
        .setIn([payload.channelName, 'errors'], [])
        .setIn([payload.channelName, 'loading'], true);

    case Constants.CONVERSATION_AGENT_TAKEOVER_RESPONDED:
      return state
        .setIn([payload.channelName, 'data'], get(payload, 'response.data.response', null))
        .setIn([payload.channelName, 'errors'], [])
        .setIn([payload.channelName, 'loading'], false);

    default:
      return state;
  }
};
